/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Operations from 'fierry/rpc/ingest/operations';


export const ingest = (application, routes, notifications) =>
{
  const operations = new Operations(routes, notifications);

  operations.upsert(application);
  operations.remove(application);
};
